import { useTranslation } from "react-i18next";
import { AiOutlineAppstore } from "react-icons/ai";
import { BiSolidPencil } from "react-icons/bi";
import { FaRegHandshake } from "react-icons/fa";
import { IoSettingsOutline } from 'react-icons/io5';
import { RiMegaphoneLine, RiPagesLine } from "react-icons/ri";
import { useLocation, useNavigate } from 'react-router-dom';
import { BASE_ROUTE, RouteName, useLocalizedRoutes } from '../../../core/constants/route_name';
import { NavItem } from '../../../core/interfaces/nav-item';
import NavSeparator from '../../../core/interfaces/nav-separator';
import { useIdentityStore } from "../../../core/store";
import NavGroupCustom from "../../components/ui/nav-group-custom/NavGroupCustom";
import NavItemCustom from '../../components/ui/nav-item-custom/NavItemCustom';



// i18n.changeLanguage('es');

const useNavSideBar = () => {
    const { t } = useTranslation();
    const ROUTE_NAME = useLocalizedRoutes();

    const navigate = useNavigate();
    const location = useLocation();
    const { identity } = useIdentityStore(state => state);

    const navSideBar: NavItem[] = [
        {
            component: NavSeparator,
            name: t('nav.dashboard'),
            roles: ["ROLE_DEVELOPER", "ROLE_ADMIN"],
        },
        {
            component: NavGroupCustom,
            name: "Páginas",
            roles: ["ROLE_DEVELOPER", "ROLE_ADMIN"],
            icon: <RiPagesLine className="nav-icon-menu" />,
            items: [
                {
                    component: NavItemCustom,
                    name: t('nav.home'),
                    roles: ["ROLE_DEVELOPER", "ROLE_ADMIN"],
                    to: BASE_ROUTE + ROUTE_NAME.home,
                    routeName: RouteName.home,
                },
                {
                    component: NavItemCustom,
                    name: "Eventos (Dinámica)",
                    roles: ["ROLE_DEVELOPER", "ROLE_ADMIN"],
                    to: BASE_ROUTE + ROUTE_NAME.spartan,
                    routeName: RouteName.spartan,
                },
                {
                    component: NavItemCustom,
                    name: "Mi Libro",
                    // roles: ["ROLE_DEVELOPER"],
                    roles: ["ROLE_DEVELOPER", "ROLE_ADMIN"],
                    to: BASE_ROUTE + ROUTE_NAME.book,
                    routeName: RouteName.book,
                }
            ]
        },

        // {
        //     component: NavSeparator,
        //     name: t('nav.calendar'),
        //     roles: ["ROLE_DEVELOPER", "ROLE_ADMIN", "ROLE_MANAGER", "ROLE_USER"],
        // },
        {
            component: NavItemCustom,
            name: t('nav.configuration'),
            roles: ["ROLE_DEVELOPER", "ROLE_ADMIN", "ROLE_USER"],
            icon: <IoSettingsOutline className="nav-icon-menu" />,
            to: BASE_ROUTE + ROUTE_NAME.configuration,
            routeName: RouteName.configuration,
        },
        {
            component: NavItemCustom,
            name: t('nav.sponsor'),
            roles: ["ROLE_DEVELOPER", "ROLE_ADMIN", "ROLE_USER"],
            icon: <FaRegHandshake className="nav-icon-menu" />,
            to: BASE_ROUTE + ROUTE_NAME.sponsor,
            routeName: RouteName.sponsor,
        },
        {
            component: NavItemCustom,
            name: t('nav.program'),
            roles: ["ROLE_DEVELOPER", "ROLE_ADMIN", "ROLE_USER"],
            icon: <AiOutlineAppstore className="nav-icon-menu" />,
            to: BASE_ROUTE + ROUTE_NAME.program,
            routeName: RouteName.program,
        },
        {
            component: NavItemCustom,
            name: t('nav.blog'),
            roles: ["ROLE_DEVELOPER", "ROLE_ADMIN", "ROLE_USER"],
            icon: <BiSolidPencil className="nav-icon-menu" />,
            to: BASE_ROUTE + ROUTE_NAME.blog,
            routeName: RouteName.blog,
        },
        ,
        {
            component: NavItemCustom,
            name: t('nav.banner'),
            roles: ["ROLE_DEVELOPER", "ROLE_ADMIN", "ROLE_USER"],
            icon: <RiMegaphoneLine className="nav-icon-menu" />,
            to: BASE_ROUTE + ROUTE_NAME.banner,
            routeName: RouteName.banner,
        }
    ];

    return navSideBar;
};

export default useNavSideBar;
